import { featuredCategories } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <section id="categories" className="py-20 md:py-28 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-14">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-3">
            Popular Categories
          </h2>
          <p className="text-foreground-600 text-base md:text-lg">
            Browse the most sought-after product categories from the AllChinaBuy Spreadsheet
          </p>
        </div>

        {/* Category Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featuredCategories.map((cat, idx) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className={`group relative overflow-hidden rounded-2xl aspect-[3/4] cursor-pointer ${
                idx === 0 ? "lg:col-span-1 lg:row-span-1" : ""
              }`}
            >
              <img
                src={cat.image}
                alt={`${cat.name} category in AllChinaBuy Spreadsheet`}
                title={`AllChinaBuy Spreadsheet ${cat.name} Category`}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
              {/* Gradient overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              {/* Text */}
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <h3 className="font-heading text-xl md:text-2xl font-semibold text-white mb-1">{cat.name}</h3>
                <p className="text-sm text-white/80">{cat.description}</p>
              </div>
            </a>
          ))}
        </div>

        {/* View All */}
        <div className="text-center mt-12">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            View All Categories
            <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
          </a>
        </div>
      </div>
    </section>
  );
}